import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IExchange } from '../../../services/rate/types';

enum RateConversion {
  cop_mxn = 'COP-MXN',
  cop_usd = 'COP-USD',
  cop_eur = 'COP-EUR',
  cop_gbp = 'COP-GBP',
  mxn_cop = 'MXN-COP',
  mxn_usd = 'MXN-USD',
  mxn_eur = 'MXN-EUR',
  mxn_gbp = 'MXN-GBP',
  usd_cop = 'USD-COP',
  usd_mxn = 'USD-MXN',
  usd_eur = 'USD-EUR',
  usd_gbp = 'USD-GBP',
  eur_usd = 'EUR-USD',
  eur_cop = 'EUR-COP',
  eur_mxn = 'EUR-MXN',
  eur_gbp = 'EUR-GBP',
  gbp_usd = 'GBP-USD',
  gbp_cop = 'GBP-COP',
  gbp_mxn = 'GBP-MXN',
  gbp_eur = 'GBP-EUR',
}

export type RealtimeCurrencyExchange =
  (typeof RateConversion)[keyof typeof RateConversion];

export type RealTimeCurrencies = Record<
  RealtimeCurrencyExchange,
  IExchange
> | null;

interface RateState {
  data: RealTimeCurrencies;
}

export const initialState: RateState = { data: null };

export const realtimeExchangeSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {
    setRealtimeData: (state, action: PayloadAction<RateState>) => {
      state.data = action.payload.data;
    },
  },
});

export const { setRealtimeData } = realtimeExchangeSlice.actions;
export default realtimeExchangeSlice.reducer;
